<template lang="pug">
  router-view
</template>

<script>

  import { getDeviceForPing } from "@/functions/device"
  import { getSessionToken, apiGetUserEmail, apiPing } from "@/services/endpoints/session"

  export default {
    mounted() {
      // Tenta enviar o sinal "Ping" logo após a montagem do componente
      this.doPing()

      // Inicia temporizador que vai enviar o "Ping" a cada 2 minutos
      const PING_INTERVAL = 2 * 60000 // Intervalo
      this.pingInterval = setInterval(() => { this.doPing() }, PING_INTERVAL)
    },

    beforeDestroy() {
      // Evita vazamento de memória
      if (this.pingInterval) clearInterval(this.pingInterval)
    },

    methods: {
      async doPing() {
        try {
          const token = await getSessionToken()

          if (token)
          {
            // GET DEVICE INFO
            // Obter device info (versão WEB)
            const device = await getDeviceForPing()

            await apiPing(token, apiGetUserEmail(), device)
          }
        } catch { }
      },
    },
  }

</script>

<style lang="sass">
  @import '@/sass/main.scss'
</style>
